import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  num: 1,
  emoji: '🎾',
  title: 'Nivelómetro 360',
  desc: 'Ubicá a cualquier alumno nuevo en su nivel real en menos de 5 minutos. Sin adivinar, sin perder clases.',
  bookBg: 'bg-tennis-green',
  bookSpine: 'bg-tennis-dark',
  bookText: 'text-white'
}, {
  num: 2,
  emoji: '📋',
  title: 'Físico Express',
  desc: 'Rutinas de preparación física de 15 minutos integradas a la clase. Más rendimiento, menos lesiones.',
  bookBg: 'bg-clay-orange',
  bookSpine: 'bg-clay-dark',
  bookText: 'text-white'
}, {
  num: 3,
  emoji: '🥗',
  title: 'Nutrición y Rendimiento',
  desc: "Qué comer y tomar antes, durante y después de la clase. Para que el alumno no 'se muera' a los 30 minutos.",
  bookBg: 'bg-ball-yellow',
  bookSpine: 'bg-yellow-500',
  bookText: 'text-tennis-dark'
}, {
  num: 4,
  emoji: '🌧️',
  title: 'Plan de Lluvia',
  desc: '10 clases teóricas de alto valor para dar bajo techo cuando llueve. Nunca más cancelar y perder el ingreso.',
  bookBg: 'bg-slate-700',
  bookSpine: 'bg-slate-900',
  bookText: 'text-white'
}, {
  num: 5,
  emoji: '🛠️',
  title: 'Kit de Supervivencia',
  desc: 'Protocolos de emergencia para grupos mixtos, sin materiales, con 20 minutos o con alumnos de mal humor.',
  bookBg: 'bg-red-700',
  bookSpine: 'bg-red-900',
  bookText: 'text-white'
}, {
  num: 6,
  emoji: '📅',
  title: 'Pack de Organización Semanal',
  desc: 'Planillas de cobro, asistencia, inventario y gestión para dominar tu semana en 15 minutos cada domingo.',
  bookBg: 'bg-tennis-light',
  bookSpine: 'bg-tennis-green',
  bookText: 'text-white'
}];
function BonusBook({
  emoji,
  num,
  bookBg,
  bookSpine,
  bookText
}: {
  emoji: string;
  num: number;
  bookBg: string;
  bookSpine: string;
  bookText: string;
}) {
  return <div className="relative w-44 sm:w-48 aspect-[3/4] mx-auto" data-id="element-18">
      {/* Book shadow */}
      <div className="absolute inset-0 bg-black/20 blur-xl translate-y-3 rounded-r-md" data-id="element-19"></div>

      {/* Book body */}
      <div className={`relative w-full h-full ${bookBg} ${bookText} rounded-r-md rounded-l-sm shadow-xl overflow-hidden flex flex-col`} data-id="element-20">
        {/* Spine */}
        <div className={`absolute left-0 top-0 bottom-0 w-3 ${bookSpine}`} data-id="element-21"></div>
        {/* Spine highlight */}
        <div className="absolute left-3 top-0 bottom-0 w-px bg-white/20" data-id="element-22"></div>

        <div className="relative flex-1 flex flex-col pl-6 pr-4 py-5" data-id="element-23">
          {/* Top icon */}
          <div className="text-3xl mb-3" data-id="element-24">{emoji}</div>

          {/* Bonus N */}
          <div className="font-display text-2xl leading-tight" data-id="element-25">Bonus {num}</div>

          {/* Filler divider */}
          <div className="flex-1" data-id="element-26"></div>
          <div className="h-px bg-current opacity-30 mb-3" data-id="element-27"></div>

          {/* Brand */}
          <div className="text-[10px] tracking-[0.2em] font-bold uppercase opacity-90" data-id="element-28">
            TENIS 360™
          </div>
        </div>
      </div>
    </div>;
}
export function Bonuses() {
  return <section className="py-20 bg-offwhite" data-id="element-29">
      <div className="max-w-6xl mx-auto px-4" data-id="element-30">
        <div className="text-center mb-12" data-id="element-31">
          <h3 className="text-4xl md:text-5xl font-display text-charcoal mb-4" data-id="element-32">
            + 6 Regalos Estratégicos
          </h3>
          <p className="text-lg md:text-xl text-gray-600 font-medium mb-8" data-id="element-33">
            Incluidos sin costo extra · Valor real del pack
          </p>

          <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-clay-orange text-white font-display text-base md:text-xl px-6 py-3 rounded-full shadow-lg" data-id="element-34">
            🎁 GRATIS POR EL DÍA DE HOY
          </motion.div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-12" data-id="element-35">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i % 3 * 0.1
        }} className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 flex flex-col items-center text-center" data-id="element-36">
              <div className="mb-6 pt-2" data-id="element-37">
                <BonusBook emoji={bonus.emoji} num={bonus.num} bookBg={bonus.bookBg} bookSpine={bonus.bookSpine} bookText={bonus.bookText} data-id="element-38" />
              </div>

              <div className="inline-block bg-green-100 text-green-700 text-xs font-bold tracking-wider px-3 py-1 rounded-full mb-5 uppercase" data-id="element-39">
                GRATIS
              </div>

              <h4 className="text-xl md:text-2xl font-bold text-charcoal mb-4 leading-tight" data-id="element-40">
                {bonus.emoji} Bonus {bonus.num} — {bonus.title}
              </h4>

              <p className="text-gray-500 leading-relaxed" data-id="element-41">{bonus.desc}</p>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-42">
          <a href="#precio" className="inline-block w-full sm:w-auto bg-clay-orange hover:bg-clay-dark text-white font-display text-xl md:text-2xl py-5 px-10 rounded-xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300" data-id="element-43">
            RECLAMAR MIS 6 BONUS GRATIS AHORA →
          </a>
        </div>
      </div>
    </section>;
}